import { KeyboardEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, TextArea } from "@carbon/react";
import { Send } from "@carbon/icons-react";
import { MAX_QUESTION_LENGTH } from "./offerAssistantUtils";

type Props = {
  disabled: boolean;
  /** `onSent` clears the input once the question was accepted. */
  onSend: (text: string, onSent: () => void) => void;
};

/** Question input: Enter sends, Shift+Enter adds a line. */
const OfferAssistantComposer = ({ disabled, onSend }: Props) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const question = text.trim();
  const canSend = !disabled && question.length > 0;

  const submit = () => {
    if (canSend) onSend(question, () => setText(""));
  };

  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (
      event.key === "Enter" &&
      !event.shiftKey &&
      !event.nativeEvent.isComposing
    ) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <form
      className="offer-assistant__composer"
      onSubmit={(event) => {
        event.preventDefault();
        submit();
      }}
    >
      <TextArea
        id="offer-assistant-input"
        labelText={t("offerAssistant.inputLabel")}
        hideLabel
        placeholder={t("offerAssistant.inputPlaceholder")}
        rows={2}
        maxCount={MAX_QUESTION_LENGTH}
        maxLength={MAX_QUESTION_LENGTH}
        value={text}
        disabled={disabled}
        onChange={(event) => setText(event.target.value)}
        onKeyDown={onKeyDown}
      />
      <Button type="submit" size="md" renderIcon={Send} disabled={!canSend}>
        {t("offerAssistant.send")}
      </Button>
    </form>
  );
};

export default OfferAssistantComposer;
